import { DOM } from './index'
import { CONFIG } from '../config';

var FAMOUS_DOM = {
    updateFamouPediaList() {
        var listDom = document.getElementById('FamousVirtualList'),
            topBarDom = document.getElementsByClassName('famous-pedia-top-bar')[0],
            bottomDom = document.getElementsByClassName('bottom-menu-bar')[0];
        if(listDom && topBarDom && bottomDom) {
            listDom.style.height = (innerHeight - topBarDom.clientHeight - bottomDom.clientHeight) + 'px';
        }
    },
    // 聚焦到底部输入框
    focusBottomBarTextArea() {
        var fakeNode = document.getElementById('commentFakeText');
        if(fakeNode) {
            fakeNode.click();
        }
    },
    hideFamousPediaCreatePage() {
        DOM.hidePageByClassName('collate-top');
        DOM.hidePageByClassName('famous-pedia-create-content');
        DOM.hidePageByClassName('collate-form');
        DOM.hidePageByClassName('advanced-collate-main');
        DOM.hidePageByClassName('famous-pedia-bottom-bar');
    },
    showFamousPediaCreatePage() {
        DOM.showPageByClassName('collate-top');
        DOM.showPageByClassName('famous-pedia-create-content');
        DOM.showPageByClassName('collate-form');
        DOM.showPageByClassName('advanced-collate-main');
        DOM.showPageByClassName('famous-pedia-bottom-bar');
    },
    hideFamousPediaPage() {
        DOM.hidePageByClassName('famous-pedia-top-bar');
        DOM.hidePageByClassName('famous-list');
        DOM.hidePageByClassName('famous-add');
    },
    showFamousPediaPage() {
        DOM.showPageByClassName('famous-pedia-top-bar');
        DOM.showPageByClassName('famous-list');
        DOM.showPageByClassName('famous-add');
    },
    updateFamousFormStyle() {
        console.log('updateFamousFormStyle-----', window.innerHeight)
        var titleDiv = document.getElementsByClassName('famous-pedia-title-bar')[0],
            topBarDiv = document.getElementsByClassName('famous-pedia-fate-topbar')[0],
            formDiv = document.getElementsByClassName('famous-pedia-create-form')[0],
            listDiv = document.getElementsByClassName('famous-comment-all-list')[0],
            bottomDiv = document.getElementsByClassName('famous-comment-bottom-bar')[0],
            allBarDiv = document.getElementsByClassName('famous-comment-all-list-top-bar')[0],
            mainListDiv = document.getElementsByClassName('famous-comment-list-box')[0];
            // wrapper = document.getElementsByClassName('wrapper')[0];

        if(titleDiv) {
            titleDiv.style = '';
        }
        if(bottomDiv) {
            bottomDiv.style = '';
        }
        if(topBarDiv && formDiv) {
            setTimeout(() => {
                formDiv.style = '';
                formDiv.style.paddingTop = topBarDiv.clientHeight + 'px';
                // formDiv.style.paddingBottom = window.innerHeight + 'px';
            }, 0);
        }
        if(topBarDiv && listDiv) {
            setTimeout(() => {
                listDiv.style = '';
                listDiv.style.paddingTop = topBarDiv.clientHeight + 'px';
            }, 0);
        }
        if(allBarDiv && mainListDiv) {
            mainListDiv.style.paddingTop = allBarDiv.clientHeight + 'px';
        }
        // if(wrapper) {
        //     wrapper.style = '';
        // }
    },
    // 递归算取前面元素的高度
    iterativeAddItemHeight(curScrollY, curItem, itemClass) {
        var scrollY = curScrollY;
        function addItemHeight(curItem, itemClass) {
            var previousItem = curItem ? curItem.previousElementSibling : null;
            if(previousItem && previousItem.className.indexOf(itemClass) != -1) {
                if(itemClass == 'famous-pedia-cf-content'){
                    scrollY += (previousItem.clientHeight + 5);
                }else{
                    scrollY += previousItem.clientHeight;
                }
                addItemHeight(previousItem, itemClass);
            }
        }
        addItemHeight(curItem, itemClass);
        return scrollY;
    },
    updateFamousEditFormScrollTop(curName) {
        var scrollY = 0;
        if(curName == '') {
            var dYunContent = document.getElementById('dayunliunian');
            scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, dYunContent, 'famous-pedia-cf-content');
        }else {
            var curDiv = document.getElementById(curName);
            if(!curDiv) { return; }
            if(curName.indexOf('dayun') != -1) {
                var dayunContent = curDiv.parentNode.parentNode.parentNode;
                var dayunTitle = curDiv.parentNode.parentNode.previousElementSibling;
                scrollY += dayunTitle.clientHeight;
                scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, dayunContent, 'famous-pedia-cf-content');
                scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, curDiv, 'layout-cfc-item');
            }else if(curName.indexOf('liunian') != -1) {
                var ddNianTitle = curDiv.parentNode.parentNode.parentNode.parentNode.previousElementSibling;
                var ddYunItem = curDiv.parentNode.parentNode.parentNode.parentNode.parentNode;
                var ddYunContent = ddYunItem.parentNode.parentNode.parentNode;
                var ddYunTitle = ddYunItem.parentNode.parentNode.previousElementSibling;
                scrollY += (ddYunTitle.clientHeight + ddNianTitle.clientHeight);
                scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, ddYunContent, 'famous-pedia-cf-content');
                scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, ddYunItem, 'layout-cfc-item');
                scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, curDiv, 'layout-cfcsc-item');
            }
        }

        // 滚动到指定位置
        setTimeout(() => {
            window.scrollTo(0, scrollY);
        }, 100);
    },
    updateFamousEditFormTextAreaScrollTop(curName, setFormStyle) {
        var scrollY = 0;
        if(curName == '') {
            var dYunContent = document.getElementById('dayunliunian');
            scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, dYunContent, 'famous-pedia-cf-content');
        }else {
            var curDiv = document.getElementById(curName);
            if(!curDiv) { return; }
            if(curName.indexOf('liunian') != -1) {
                var childTitle = curDiv.childNodes[0],
                    childParagraph = curDiv.childNodes[1].childNodes[0].childNodes[0],
                    ddNianTitle = curDiv.parentNode.parentNode.parentNode.parentNode.previousElementSibling,
                    ddYunItem = curDiv.parentNode.parentNode.parentNode.parentNode.parentNode,
                    ddYunContent = ddYunItem.parentNode.parentNode.parentNode,
                    ddYunTitle = ddYunItem.parentNode.parentNode.previousElementSibling;
                scrollY += (childTitle.clientHeight + ddYunTitle.clientHeight + ddNianTitle.clientHeight);
                scrollY += childParagraph && childParagraph.clientHeight ? childParagraph.clientHeight + 5 : 25;
                scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, ddYunContent, 'famous-pedia-cf-content');
                scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, ddYunItem, 'layout-cfc-item');
                scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, curDiv, 'layout-cfcsc-item');
            }else {
                var baseParagraph = curDiv.parentNode.previousElementSibling,
                    baseTitle = baseParagraph.previousElementSibling,
                    contentDiv = baseTitle.parentNode;
                scrollY += (baseParagraph.clientHeight + baseTitle.clientHeight);
                scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, contentDiv, 'famous-pedia-cf-content')
            }
        }

        var formDiv = document.getElementsByClassName('famous-pedia-create-form')[0],
            topBarDiv = document.getElementsByClassName('famous-pedia-fate-topbar')[0],
            titleDiv = document.getElementsByClassName('famous-pedia-title-bar')[0],
            topNum = parseInt(formDiv.style.paddingTop);

        if(!setFormStyle) {
            setTimeout(() => {
                window.scrollTo(0, scrollY);
            }, 100);
            if(titleDiv) {
                titleDiv.style = '';
            }
            if(formDiv && topBarDiv) {
                formDiv.style = '';
                formDiv.style.paddingTop = topBarDiv.clientHeight + 'px';
            }
        }else {
            // 滚动到指定位置之后，ios重置样式
            setTimeout(() => {
                window.scrollTo(0, 0);
                titleDiv.style = 'position: absolute; left: 0; top: -' + titleDiv.clientHeight + 'px';
                formDiv.style = 'position: absolute; left: 0; top: ' + (topNum - scrollY - titleDiv.clientHeight) + 'px';
            }, 100);
        }

    },
    updateFamousReadStoryScrollTop(curName) {
        var scrollY = 0,
            tabNode = document.getElementsByClassName('famous-pedia-cf-tab')[0],
            infoNode = document.getElementsByClassName('famous-pedia-cf-info')[0];
        scrollY += tabNode ? tabNode.clientHeight : 0;
        scrollY += infoNode ? infoNode.clientHeight : 0;
        
        if(curName != '') {
            var curDiv = document.getElementById(curName);
            if(!curDiv) { return; }
            if(curName.indexOf('dayun') != -1) {
                var boxNode = curDiv.parentNode;
                scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, boxNode, 'famous-pedia-create-dyln-item-box');
            } else if(curName.indexOf('liunian') != -1) {
                var lnBoxNode = curDiv.parentNode,
                    lnTitle = lnBoxNode.parentNode.previousElementSibling,
                    dyBoxNode = lnTitle ? lnTitle.parentNode.parentNode : null,
                    dyTitle = dyBoxNode ? dyBoxNode.parentNode.previousElementSibling : null;
                if(dyTitle) {
                    scrollY += (dyTitle.clientHeight + 5);
                }
                if(dyBoxNode) {
                    scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, dyBoxNode, 'famous-pedia-create-dyln-item-box');
                }
                if(lnBoxNode) {
                    scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, lnBoxNode, 'famous-pc-dyln-liunian-item-box');
                    scrollY = scrollY+50;
                }
            }
            scrollY = scrollY+60;
            // 滚动到指定位置
            setTimeout(() => {
                window.scrollTo(0, scrollY);
            }, 100);
        }else {
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 100);
        }
        
    },
    updateFamousReadCommentScrollTop(curName) {
        var scrollY = 0,
            tabNode = document.getElementsByClassName('famous-pedia-cf-tab')[0],
            infoNode = document.getElementsByClassName('famous-pedia-cf-content')[0];
        scrollY += tabNode ? tabNode.clientHeight : 0;
        scrollY += infoNode ? infoNode.clientHeight : 0;

        if(curName != '') {
            var curDiv = document.getElementById(curName);
            if(!curDiv) { return; }
            if(curName.indexOf('dayun') != -1) {
                var boxNode = curDiv.parentNode;
                scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, boxNode, 'famous-pedia-create-dyln-item-box');
            } else if(curName.indexOf('liunian') != -1) {
                var lnBoxNode = curDiv.parentNode,
                    lnTitle = lnBoxNode.parentNode.previousElementSibling,
                    dyBoxNode = lnTitle.parentNode.parentNode,
                    dyTitle = dyBoxNode.parentNode.previousElementSibling;
                scrollY += (dyTitle.clientHeight - 10);
                scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, dyBoxNode, 'famous-pedia-create-dyln-item-box');
                scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, lnBoxNode, 'famous-pc-dyln-liunian-item-box');
            }
            scrollY = scrollY+100;
            // 滚动到指定位置
            setTimeout(() => {
                window.scrollTo(0, scrollY);
            }, 100);
        }else {
            setTimeout(() => {
                window.scrollTo(0, 0)
            }, 100);
        }
    },
    updateFamousFormTextAreaScrollTop(curNode, setFormStyle) {
        if(CONFIG.platform == 'web') {
            return;
        }
        console.log('updateFamousFormTextAreaScrollTop------', curNode, setFormStyle)
        var scrollY = 0,
            curName = curNode.className;
        if(curName.indexOf('famous-pedia-create-edit-panel') != -1) {
            var titleNode = curNode.previousElementSibling;
            scrollY += titleNode.clientHeight;
            var dayunCotent = titleNode.parentNode;
            scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, dayunCotent, 'famous-pedia-cf-content');
        }
        if(curName.indexOf('layout-fpc-ln-subc-paragraph') != -1) {
            var lnTitle = curNode.parentNode.parentNode.previousElementSibling,
                lnBoxNode = lnTitle.parentNode,
                dyTitle = lnBoxNode.parentNode.parentNode.parentNode.parentNode.previousElementSibling,
                dyBoxNode = dyTitle.parentNode,
                dylnTitle = dyBoxNode.parentNode.parentNode.previousElementSibling,
                dylnBoxNode = dylnTitle.parentNode;
            scrollY += (lnTitle.clientHeight + dyTitle.clientHeight + dylnTitle.clientHeight);
            scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, dylnBoxNode, 'famous-pedia-cf-content');
            scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, dyBoxNode, 'layout-cfc-item');
            scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, lnBoxNode, 'layout-cfcsc-item');
            // console.log('------', lnTitle, lnBoxNode, dyTitle, dyBoxNode, dylnTitle, dylnBoxNode)
        }

        // 滚动到指定位置
        if(!setFormStyle) {
            window.scrollTo(0, scrollY);
        }else {
            // 滚动到指定位置之后，ios重置样式
            var formDiv = document.getElementsByClassName('famous-pedia-create-form')[0],
                titleDiv = document.getElementsByClassName('famous-pedia-title-bar')[0],
                topNum = parseInt(formDiv.style.paddingTop);
            setTimeout(() => {
                window.scrollTo(0, 0);
                titleDiv.style = 'position: absolute; left: 0; top: -' + titleDiv.clientHeight + 'px';
                formDiv.style = 'position: absolute; left: 0; top: ' + (topNum - scrollY - titleDiv.clientHeight) + 'px';
            }, 100);
        }
    },
    updateFamousFormBottomTextAreaScrollTop(curId, setFormStyle) {
        var scrollY = 0,
            tabNode = document.getElementsByClassName('famous-pedia-cf-tab')[0],
            curNode = document.getElementById(curId),
            preCommentList = curNode.parentNode.previousElementSibling,
            curParent = curNode.parentNode.parentNode.parentNode;
        // 叠加行高
        scrollY += tabNode.clientHeight;
        scrollY += (preCommentList ? preCommentList.clientHeight : 10);
        // console.log('updateFamousFormBottomTextAreaScrollTop-----', curNode, preCommentList, curParent.className)
        // 区分输入框
        if(curParent.className.indexOf('famous-pc-content') != -1) {
            var titleNode = curParent.previousElementSibling;
            scrollY += titleNode.clientHeight;
        }
        if(curParent.className.indexOf('famous-pc-dyln-ln-paragraph') != -1){
            var lnContent = curNode.parentNode.parentNode.previousElementSibling,
                lnTitle = curParent.previousElementSibling,
                lnBoxNode = lnTitle.parentNode.parentNode,
                dyTitle = lnBoxNode.parentNode.previousElementSibling,
                dyBoxNode = dyTitle.parentNode.parentNode,
                dylnTitle = dyBoxNode.parentNode.previousElementSibling,
                dylnBoxNode = dylnTitle.parentNode;
            scrollY += (lnContent ? lnContent.clientHeight : 0);
            scrollY += (lnTitle.clientHeight + dyTitle.clientHeight + 30 + dylnTitle.clientHeight);
            scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, dylnBoxNode, 'famous-pedia-cf-content');
            scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, dyBoxNode, 'famous-pedia-create-dyln-item-box');
            scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, lnBoxNode, 'famous-pc-dyln-liunian-item-box');
        }
        // 滚动到指定位置
        if(!setFormStyle) {
            window.scrollTo(0, scrollY);
        }else {
            setTimeout(() => {
                window.scrollTo(0, 0);
            }, 10);
            // 滚动到指定位置之后，ios重置样式
            var titleDiv = document.getElementsByClassName('famous-pedia-title-bar')[0],
                formDiv = document.getElementsByClassName('famous-pedia-create-form')[0],
                topNum = parseInt(formDiv.style.paddingTop);
            if(titleDiv && formDiv && topNum) {
                setTimeout(() => {
                    titleDiv.style = 'position: absolute; left: 0; top: -' + titleDiv.clientHeight + 'px';
                    formDiv.style = 'position: absolute; left: 0; top: ' + (topNum - scrollY - titleDiv.clientHeight) + 'px';
                }, 100);
            }
        }
    },
    updateFamousFormBottomBarScrollTop() {
        // ios重置样式
        var formDiv = document.getElementsByClassName('famous-pedia-create-form')[0],
            listDiv = document.getElementsByClassName('famous-comment-all-list')[0],
            titleDiv = document.getElementsByClassName('famous-pedia-title-bar')[0],
            barDiv = document.getElementsByClassName('famous-comment-all-list-top-bar')[0],
            bottomDiv = document.getElementsByClassName('famous-comment-bottom-bar')[0],
            // wrapper = document.getElementsByClassName('wrapper')[0],
            topNum = 0, bottomNum = 0;
        if(titleDiv && formDiv) {
            topNum = parseInt(formDiv.style.paddingTop);
            setTimeout(() => {
                titleDiv.style = 'position: absolute; left: 0; top: -' + titleDiv.clientHeight + 'px';
                formDiv.style = 'position: absolute; left: 0; top: ' + (topNum - titleDiv.clientHeight) + 'px';
            }, 100);
        }
        if(titleDiv && listDiv) {
            topNum = parseInt(listDiv.style.paddingTop);
            setTimeout(() => {
                titleDiv.style = 'position: absolute; left: 0; top: -' + titleDiv.clientHeight + 'px';
                listDiv.style = 'position: absolute; left: 0; top: ' + (topNum - titleDiv.clientHeight) + 'px';
            }, 100);
        }
        
        bottomNum = barDiv ? barDiv.clientHeight : 0;
        bottomNum = bottomNum - titleDiv.clientHeight;
        setTimeout(() => {
            window.scrollTo(0, 0)
            // if(wrapper) {
            //     wrapper.style = 'height: ' + innerHeight/2 + 'px; overflow: hidden;';
            // }
            if(bottomDiv) {
                bottomDiv.style = 'position: absolute; left: 0; top: ' + bottomNum + 'px';
            }
        }, 300);
    },
    // 获取大运标题的位置
    getFamousFormReadDayunScrollY(scrollY, curName) {
        var curDiv = document.getElementById(curName);
        if(!curDiv) { return scrollY; }
        var dayunContent = curDiv.parentNode,
            dayunTitle = curDiv.parentNode.parentNode.previousElementSibling;
        if(dayunTitle) {
            scrollY += (dayunTitle.clientHeight + 30);
        }
        if(dayunContent) {
            scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, dayunContent, 'famous-pedia-create-dyln-item-box');
        }
        return scrollY;
    },
    // 获取流年标题的位置
    getFamousFormReadLiunianScrollY(scrollY, curName) {
        var curDiv = document.getElementById(curName);
        if(!curDiv) { return scrollY; }
        var liunianItem = curDiv.parentNode,
            liunianTitle = curDiv.parentNode.parentNode.previousElementSibling,
            dayunItem = liunianTitle.parentNode.parentNode,
            dayunTitle = dayunItem.parentNode.previousElementSibling;
        if(liunianTitle) {
            scrollY += liunianTitle.clientHeight;
        }
        if(dayunTitle) {
            scrollY += (dayunTitle.clientHeight + 10);
        }
        scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, dayunItem, 'famous-pedia-create-dyln-item-box');
        scrollY = FAMOUS_DOM.iterativeAddItemHeight(scrollY, liunianItem, 'famous-pc-dyln-liunian-item-box');
        return scrollY;
    },
    bindFamousFormScrollEvent(binded) {
        if(!binded) {
            window.onscroll = null;
            return;
        }
        var lowestY = 0,
            dYunContent = document.getElementById('dayunliunian'),
            tabContent = document.getElementsByClassName('famous-form-rw-tab')[0];

        if(tabContent) {
            lowestY += (tabContent.clientHeight + 50);
        }
        lowestY = FAMOUS_DOM.iterativeAddItemHeight(lowestY, dYunContent, 'famous-pedia-cf-content');

        var totalIdList = [], totalScrollYList = [];
        var dYunList = document.getElementsByClassName('famous-pedia-create-dyln-list')[0];
            dYunList = dYunList ? dYunList.childNodes : [];
        for(var x = 0; x < dYunList.length; x++) {
            if(dYunList[x].clientHeight > 0) {
                if(dYunList[x].childNodes[0] && dYunList[x].childNodes[0].id) {
                    totalIdList.push(dYunList[x].childNodes[0].id);
                    var dYunScrollY = FAMOUS_DOM.getFamousFormReadDayunScrollY(lowestY, dYunList[x].childNodes[0].id);
                    totalScrollYList.push(dYunScrollY);
                }
            }
            var lNianList = dYunList[x].clientHeight > 0 && dYunList[x].childNodes[0].childNodes[1] ? dYunList[x].childNodes[0].childNodes[1].childNodes : [];
            if(lNianList.length > 0) {
                for(var y = 0; y < lNianList.length; y++) {
                    if(lNianList[y].clientHeight > 0) {
                        if(lNianList[y].childNodes[0] && lNianList[y].childNodes[0].id) {
                            totalIdList.push(lNianList[y].childNodes[0].id);
                            var lNianScrollY = FAMOUS_DOM.getFamousFormReadLiunianScrollY(lowestY, lNianList[y].childNodes[0].id);
                            totalScrollYList.push(lNianScrollY);
                        }
                    }
                }
            }
        }
        // console.log('bindFamousFormScrollEvent------', totalIdList, totalScrollYList)
        // 先解绑后再绑定一次
        var resetedFortune = 1;
        window.onscroll = null;
        window.onscroll = function() {
            var listL = totalScrollYList.length,
                scrollY = document.documentElement.scrollTop || document.body.scrollTop;
            for(var i = 0; i < listL; i++) {
                if((i < (listL-1) && scrollY > totalScrollYList[i] - 40 && scrollY <= totalScrollYList[i+1]) || (i == (listL -1) && scrollY > totalScrollYList[i] - 40)) {
                    // console.log('scroll----to-----', scrollY, totalIdList[i], totalScrollYList[i], totalScrollYList[i+1], )
                    AppFate.$store.dispatch('minifatefortune/triggerFortuneItemFunction', totalIdList[i]);
                    resetedFortune = 1;
                }else if(scrollY <= lowestY) {
                    AppFate.$store.dispatch('minifatefortune/triggerFortuneItemDeleteFunction', totalIdList[i]);
                    if(resetedFortune <= 80) {
                        AppFate.$bus.emit('updateFortuneDom');
                    }
                    resetedFortune++;
                }
            }
        }
    }
}
export {
    FAMOUS_DOM
}